module.exports = __webpack_public_path__ + "static/media/ic_device_grey.3fca686e.svg";